<style>
    .assessment-dropdown-container {
        position: relative;
        font-size: .9rem;
        background-color: #fff;
    }
    .assessment-dropdown-trigger {
        border: solid 2px;
        border-radius: 5px;
        padding: .5rem .8rem;
        cursor: pointer;
    }
    .expanded .assessment-dropdown-trigger {
        border-radius: 5px 5px 0px 0px;
    }
    .finnished-assessment-list {
        position: absolute;
    }
    .expanded .finished-assessment-list {
        border: solid 2px;
        border-top: none !important;
        padding: .5rem 0;
    }

    .finished-assessment-list li{
        padding: 0 .5rem;
    }
    .finished-assessment-list li:hover{
        background-color: #ebf5f8;
    }
    .finished-assessment-list li a {
        text-decoration: none;
        color: inherit
    }
    .vertical-bar {
        float: right;
        border-width: 0 0 0 2px !important;
        height: 24px;
        line-height: 24px;
        padding: 0 0 0 .8rem;
        vertical-align: middle;
        width: 24px;
        font-size: 1.2em;
    }
</style>

<template>
  <div class="assessment-dropdown-container" :class="{ expanded: expanded }">
    <div @click="expanded = !expanded" class="assessment-dropdown-trigger clearfix" :class="'border-' + module.color">
      View Completed
      <div class="vertical-bar" :class="'border-' + module.color + ' text-' + module.color">
        <span v-show="!expanded"><span class="fa fa-chevron-right" style="padding-top: 2px;"></span></span>
        <span v-show="expanded"><span class="fa fa-chevron-down"></span></span>
      </div>
    </div>
    <ul class="finished-assessment-list list-unstyled" v-show="expanded" :class="'border-' + module.color">
      <li v-for="ass in finishedAssessments" :key="ass.id.toString() + ass.survey_id.toString()">
        <a :href="$basePath + '/self-assessments/' + module.slug + '/' + ass.id + '/results'" class="d-block">Completed: {{ formatDate(ass.finalized_at) }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
    import moment from 'moment'
    export default {
        components: {},
        props: {
            assessments: {
                required: true,
                type: Array
            },
            module: {
                required: true,
                type: Object
            }
        },
        data() {
            return {
                expanded: false
            }
        },
        computed: {
            finishedAssessments: function() {
                return this.assessments.filter(ass => ass.finalized_at !== null)
            },
            formatDate: function (dateString) {
                return moment(dateString).format('MM/DD/YYYY');
            },
            $basePath() {
              return window.basePath;
            }
        },
        methods: {
        }
    }
</script>